import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatAnchor } from '@angular/material/button';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { LoginService } from '@app/services';
import { AuthService, User } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';

@Component({
  selector: 'qb-navigation-menu',
  templateUrl: './navigation-menu.component.html',
  styleUrls: ['./navigation-menu.component.scss'],
  imports: [MatAnchor, RouterLink, RouterLinkActive, AsyncPipe],
})
export class NavigationMenuComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  currentUser$: Observable<User | null | undefined>;
  readonly router = inject(Router);
  readonly managementRoutes = ['/agency/admin', '/agency/user', '/agency/role'];

  constructor(
    private auth: AuthService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.currentUser$ = this.auth.user$.pipe(takeUntilDestroyed(this.destroyRef));
  }

  get isAuthenticated(): boolean {
    return !!this.loginService.user;
  }

  get isVendor(): boolean {
    return this.loginService.isVendor;
  }

  get isAgency(): boolean {
    return this.loginService.isAgency;
  }

  get isQbat(): boolean {
    return this.loginService.isQbat;
  }

  hasPermission(permission: string): Observable<boolean> {
    return this.loginService.hasPermission(permission);
  }

  canAccessFeature(feature: string): boolean {
    return this.loginService.canAccessFeature(feature);
  }
}
